<template>
    <page-container style="flex-direction: column;">
        <div style="color:#409EFF; margin-top: 20px; font-size: 32px;">欢迎访问，汇利弘进销存管理系统</div>


    </page-container>
</template>

<script>
export default {
    name: "Dashboard",
    data()
    {
        return {
            orderWaitAuditNum: 0,
            orderPaidNum: 0,
            orderShippedNum: 0,
            orderCompleteNum: 0,
            userNum: 0,
            rechargeNum: 0,
            withdrawalNum: 0
        }
    },
    created (){
    },
    methods: {

    }
}
</script>

<style scoped>
.grid-content{
    align-items: center;
    display: flex;
    cursor: pointer;
}
.grid-content .num{
    color: red;
    font-size: 24px;
    font-weight: bold;
    text-decoration: underline;
    padding: 0px 15px;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/dashboard/Dashboard.vue